import { useEffect, useState } from 'react';
import DatePicker from 'react-datepicker';
import { BeatLoader } from 'react-spinners';
import { getRegistrarSettleDashData, getTransactionReconcileCSV } from 'store/actions/lead.action';

interface renconcileData {
  RegistrarId: string;
  LeadSource: string;
  Success: number;
  Refunds: number;
  Payable: number;
}

const truncDecimal = (value: number) => parseFloat(value.toString()).toFixed(2);

const ReconcileDashboard = () => {
  const [startDate, setStartDate] = useState(new Date(new Date().getFullYear(), new Date().getMonth(), 1));
  const [endDate, setEndDate] = useState(new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0));
  const [fetchingData, setFetchingData] = useState(false);
  const [settleData, setSettleData] = useState([]);

  const onFilterChange = (x: Date) => {
    setStartDate(x);
    const end = new Date(x.getFullYear(), x.getMonth() + 1, 0);
    setEndDate(end);
  };

  useEffect(() => {
    if (startDate && endDate) {
      setFetchingData(true);
      getRegistrarSettleDashData({ startDate, endDate })
        .then((res) => res.data)
        .then((data) => {
          setFetchingData(false);
          setSettleData(data);
        })
        .catch(() => setFetchingData(false));
    }
  }, [startDate, endDate]);

  const getTransactionConcile = async () => {
    const data = { startDate, endDate };
    await getTransactionReconcileCSV(data);
  };

  return (
    <div className="mt-2 mb-4 overflow-x-auto">
      <div className="py-2 d-flex flex-column flex-sm-row align-items-center justify-content-between">
        <div>
          <label className="mb-n1">Select month</label>
          <DatePicker selected={startDate} maxDate={new Date()} onChange={(x) => x && onFilterChange(x)} dateFormat="MM/yyyy" showMonthYearPicker className="w-fc" placeholderText={'Select Month'}></DatePicker>
        </div>
        <div>
          {settleData && settleData.length > 0 && (
            <button className=" btn fs-18 btn-grad" onClick={() => getTransactionConcile()}>
              Download
            </button>
          )}
        </div>
      </div>
      <div className="table-responsive">
        <table className="table text-center table table-striped table-hover">
          <thead>
            <tr className="">
              <th scope="col" className="text-nowrap">
                Lead Source
              </th>
              <th scope="col">Success</th>
              <th scope="col">Refunds</th>
              <th scope="col">Payable</th>
            </tr>
          </thead>
          <tbody>
            {fetchingData ? (
              <tr>
                <td colSpan={10} className="text-center table-loader">
                  <BeatLoader color="#ff7728" />
                </td>
              </tr>
            ) : !settleData || settleData.length === 0 ? (
              <tr>
                <td colSpan={10} className="text-center">
                  No Record found
                </td>
              </tr>
            ) : Array.isArray(settleData) ? (
              <>
                {settleData
                  .sort((a: renconcileData, b: renconcileData) => (a.LeadSource ? -1 : 1))
                  .map((data: renconcileData, i) => (
                    <tr key={data.RegistrarId || i}>
                      <th scope="row" className="text-nowrap">
                        {data.LeadSource || 'buy.saw.com'}
                      </th>
                      <th>{data.Success}</th>
                      <th>{data.Refunds}</th>
                      <th>{data.Payable}</th>
                    </tr>
                  ))}
                <tr className="f-bold theme-background">
                  <th scope="row">Total</th>
                  <th>{truncDecimal(settleData.map((x: renconcileData) => x.Success).reduce((a, v) => a + v, 0))}</th>
                  <th>{truncDecimal(settleData.map((x: renconcileData) => x.Refunds).reduce((a, v) => a + v, 0))}</th>
                  <th>{truncDecimal(settleData.map((x: renconcileData) => x.Payable).reduce((a, v) => a + v, 0))}</th>
                </tr>
              </>
            ) : null}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ReconcileDashboard;
